// A quien se puede agregar a una familia.
//
// El filtro anterior descartaba a quien estuviera en CUALQUIER familia. Tenia sentido
// cuando pertenecer a una era la excepcion; dejo de tenerlo cuando toda ficha pasa a
// tener familia: en produccion 205 de los 206 jugadores de un club ya tienen una, asi
// que la lista salia vacia siempre y no se podia agregar a nadie.
//
// Ahora solo se excluye a los de ESTA familia -- que ya se listan arriba como
// "Miembros actuales" -- y a los de otra se les dice de cual, porque moverlos los saca
// de la suya: sus cargos y su estado de cuenta cuelgan de esa familia.
export const candidatosParaFamilia = ({
  jugadores = [],
  familias = [],
  familiaActualId = null,
  busqueda = '',
  tope = 10,
} = {}) => {
  const termino = (busqueda || '').trim().toLowerCase()
  if (!termino) return []

  const familiaDe = new Map()
  ;(familias || []).forEach((f) => {
    ;(f?.jugadores || []).forEach((j) => {
      if (j?.id) familiaDe.set(j.id, { id: f.id, nombre: f.nombre })
    })
  })

  return (jugadores || [])
    .filter((p) => {
      if (!p?.id) return false
      if (familiaDe.get(p.id)?.id === familiaActualId) return false
      const nombre = (p.nombre_completo || '').toLowerCase()
      return nombre.includes(termino) || String(p.numero ?? '').includes(termino)
    })
    .slice(0, tope)
    .map((p) => ({ ...p, familiaActual: familiaDe.get(p.id) || null }))
}
